import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { blobConnectionInitialValue } from 'components/organisms/forms/blob-connection/BlobConnectionForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiFloppyDisk, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  useGetProviderBlobConnection,
  usePutProviderBlobConnection,
} from 'services/providers/blob';
import { IProviderBlobConnectionResponse } from 'services/providers/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const EditBlobConnection = () => {
  const providerId = useCustomParamId('id', 'settings/provider');
  const salesChannelId = useCustomParamId(
    'salesChannelId',
    `settings/provider/${providerId}`
  );

  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const blobConnection = useGetProviderBlobConnection(
    providerId,
    salesChannelId
  );

  const updateBlobConnection = usePutProviderBlobConnection();
  const mutateOptions = useMutateOptions<IProviderBlobConnectionResponse>();

  const onGoToDetail = () =>
    navigate(
      `/settings/provider/${providerId}/blob-connection/${salesChannelId}/keys`
    );

  const submitForm = async (
    values: IProviderBlobConnectionResponse,
    helpers: FormikHelpers<IProviderBlobConnectionResponse>
  ) => {
    await updateBlobConnection.mutateAsync(
      {
        ...values,
        salesChannelId: salesChannelId,
        providerId: providerId,
      },
      {
        onSuccess: onGoToDetail,
        ...mutateOptions(helpers),
      }
    );
  };

  return (
    <Form.BlobConnection
      i18nextPrefix='label'
      initialValues={
        blobConnection.data ? blobConnection.data : blobConnectionInitialValue
      }
      onSubmit={submitForm}
      customBackItem={
        <Button
          onlyIcon
          onClick={() => {
            navigate(
              `/settings/provider/${providerId}/blob-connection/${salesChannelId}/keys`
            );
          }}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
          <Button.Icon icon={<PiFloppyDisk />} />
        </Button>
      }
      status={{ isLoading: blobConnection.isLoading }}
    />
  );
};

export default EditBlobConnection;
